<template>
  <div class="dropdown-group">
    <label class="question-label">{{ label }}</label>
    <div class="dropdown-wrapper" @blur="isOpen = false" v-click-outside="() => (isOpen = false)">
      <button :class="{ dropdown: true, open: isOpen}" @click.prevent="isOpen = !isOpen">
        {{ selected !== null ? options[selected].text : caption }}
        <i
          :class="{arrow: true, down: !isOpen, up: isOpen}"
        ></i>
      </button>
      <div :class="{ options: true, selectShow: isOpen}" v-show="isOpen">
        <div
          class="option"
          v-for="(option, i) of options"
          :key="i"
          @click="
          isOpen = false;
          selected = i;
          $emit('changed', option.id, option.nextGroupID);
        "
        >{{ option.text }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { clickOutside } from "../directives/click-outside";

export default {
  name: "Dropdown",
  directives: {
    clickOutside
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    caption: {
      type: String,
      required: true
    },
    label: {
      type: String
    }
  },
  data: function() {
    return {
      isOpen: false,
      selected: null
    };
  }
};
</script>
<style lang="scss" scoped>
.dropdown-group {
  margin: 0 0 35px;
  &:last-child {
    margin-bottom: 0;
  }
}

.dropdown-wrapper {
  position: relative;

  .options {
    border-radius: 0px 0px 30px 30px;
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    background-color: $color-white;
    box-shadow: 0 3px 20px rgba(0, 0, 0, 0.06);
    border: 1px solid #ececec;
    z-index: 2;

    .option {
      padding: 19px;
      cursor: pointer;
      user-select: none;
      text-align: center;
      border-bottom: 1px solid #ececec;
      color: $color-primary;

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .selectShow {
    opacity: 1;
  }
}

.dropdown {
  background: #fff;
  padding: 19px 80px;
  color: $color-gray;
  border-radius: 30px;
  cursor: pointer;
  width: 100%;
  text-align: center;
  user-select: none;
  font-family: "CleanOT", sans-serif;
  box-shadow: 0 3px 20px rgba(0, 0, 0, 0.16);
  border: none;
  will-change: border-radius;
  transition: 0.2s border-radius;
  position: relative;

  &.open {
    border-radius: 30px 30px 0 0;
  }

  &:focus {
    outline: 0;
  }
  z-index: 1;
}

.question-label {
  font-family: "Open Sans", sans-serif;
  text-align: center;
  font-size: 22px;
  color: $color-primary;
  margin-bottom: 25px;
  display: block;
}

i.arrow {
  border: solid $color-gray;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 8px;
  top: 18px;
  position: absolute;
  right: 26px;
}

i.up {
  transform: rotate(-135deg) translateY(-60%);
}

i.down {
  transform: rotate(45deg) translateY(-15%);
  right: 36px;
}

@keyframes slideInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -50%, 0);
    visibility: visible;
  }

  20% {
    opacity: 0;
  }

  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes slideOutDown {
  0% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  20% {
    opacity: 1;
  }
  100% {
    visibility: hidden;
    opacity: 0;
    transform: translate3d(0, -50%, 0);
  }
}

$fades: Down;
@include make-transitions(slide, $fades);

@media (max-width: 600px) {
  .dropdown {
    text-align: left;
    padding: 17px 31px;
  }
  .dropdown-wrapper {
    .options {
      .option {
        padding: 17px 31px;
        text-align: left;
      }
    }
  }
  .question-label {
    font-size: 20px;
  }
}
</style>